import type { EducationLevelModel, UsStateOrTerritoryModel } from '@/apiTypes/UserTypes';

export const getStateResidenceDisplay = (allStates: UsStateOrTerritoryModel[], stateId: string): string => {
    if (!stateId || !allStates.length) return '';
    const idOrAbbrOrName = String(stateId).trim();
    const state = allStates.find(
        s =>
            s.id === idOrAbbrOrName
            || s.abbreviation === idOrAbbrOrName
            || s.name === idOrAbbrOrName,
    );
    return state ? `${state.name} (${state.abbreviation})` : '';
};

export const getEducationStatusDisplay = (allEducationLevels: EducationLevelModel[], educationLevelId: string): string => {
    if (!educationLevelId || !allEducationLevels.length) return '';
    const idOrName = String(educationLevelId).trim();
    const edu = allEducationLevels.find(
        e => e.id === idOrName || e.name === idOrName,
    );
    return edu?.name ?? '';
};

export const getInitials = (firstName?: string, middleName?: string, lastName?: string) => {
    const firstInitial = firstName ? firstName.charAt(0).toUpperCase() : '';
    const middleInitial = middleName ? middleName.charAt(0).toUpperCase() : '';
    const lastInitial = lastName ? lastName.charAt(0).toUpperCase() : '';

    return `${firstInitial}${middleInitial}${lastInitial}`;
};
